
import { defineComponent, PropType, computed } from 'vue'
import { AutoCollectApplicant } from '@/data/dms/dmsData'
import ConfirmInput from '@/components/organisms/dms/common/ConfirmInput.vue'

export default defineComponent({
  name: 'UserDataConfirm',
  components: {
    ConfirmInput,
  },
  props: {
    modelValue: {
      type: Object as PropType<AutoCollectApplicant>,
    },
  },
  setup (props, { emit }) {
    const state = computed({
      get: () => props.modelValue,
      set: (state) =>
        emit('update:modelValue', state),
    })
    return {
      props,
      state,
    }
  },
})
